<template>
  <modal
    v-if="show && video"
    :scrollY="false"
    :showCloseBtn="true"
    @leave="close()"
  >
    <div class="flex h-full flex-col justify-center items-center">
      <div class="font-medium text-lg text-left mb-4">
        Download video:
      </div>
      <div class="mb-4 text-left flex flex-col items-center">
        <span class="mb-2 text-lg">{{ name }}</span>
        <div class="text-sm text-grey-dark text-right" v-if="(created = formatCreatedAt(video.created_at))">
          {{ created.date }} {{ created.time }}
        </div>
      </div>
      <div class="mt-auto flex items-center">
        <button
          @click="download('16:9')"
          class="py-3 px-6 w-48 bg-secondary rounded mr-4"
          :class="{ 'cursor-not-allowed': loading }"
          :disabled="loading"
        >
          Standard (16:9)
        </button>
        <button
          @click="download('1:1')"
          class="py-3 px-6 w-48 bg-secondary rounded"
          :class="{ 'cursor-not-allowed': loading }"
          :disabled="loading"
        >
          Social (1:1)
        </button>
      </div>
    </div>
  </modal>
</template>

<script>
import api from '@/http'
import moment from 'moment'

export default {
  name: 'VideoetteDownloadModal',

  props: ['show', 'video'],

  data () {
    return {
      loading: false
    }
  },

  computed: {
    name () {
      return this.video.name || this.video.display_address
    }
  },

  methods: {
    formatCreatedAt (timestamp) {
      if (!timestamp) {
        return false
      }

      let localTime = moment.unix(timestamp).local()

      return {
        date: localTime.format('Do MMMM YYYY'),
        time: localTime.format('HH:mm')
      }
    },

    download (ratio) {
      this.loading = true

      api
        .get(`videoettes/download/${this.video.video_id}`, {
          params: { ratio: ratio }
        })
        .then(response => {
          window.location.assign(response.data.url)
        })
        .catch(() => {
          this.close()
        })
        .finally(() => {
          this.loading = false
        })
    },

    close () {
      this.loading = false
      this.$emit('close')
    }
  }
}
</script>
